import EVENTS from '../../constants/xray-ui_events.constants';

export class AlertsController {
    constructor($q, $scope, $stateParams, $timeout, $state, AlertsDao, JFrogGridFactory, JFrogModal, uiGridConstants,
                JFrogEventBus, IgnoreModal, IgnoreDao, User, $compile, $location, XRayUIPermissions) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.XRayUIPermissions = XRayUIPermissions;
        this.$compile = $compile;
        this.$location = $location;
        this.$state = $state;
        this.$q = $q;
        this.alertsDao = AlertsDao;
        this.ignoreDao = IgnoreDao;
        this.jfrogGridFactory = JFrogGridFactory;
        this.modal = JFrogModal;
        this.uiGridConstants = uiGridConstants;
        this.IgnoreModal = IgnoreModal;
        this.user = User.getCurrent();
        this.defaultPagination = {direction: 'desc', num_of_rows: 20, order_by: 'created_at', page_num: 1};
        this.currentTab = this.$stateParams.tab || 'user';
        this._createGrids();

        this.tabs = [{name: 'user'}, {name: 'ignoreRules'}];
        this.baseTabsDict = {user: 'Alerts', ignoreRules: 'Ignore Rules'};
        this.tabsDict = _.cloneDeep(this.baseTabsDict);

        this._getIgnoreRules();


        let removeListener = JFrogEventBus.register(EVENTS.ALERTS_REFRESH, () => {
            this.refreshAlertGrid();

	        this.setTabCounter();
        });

        $scope.$on('$destroy', () => {
            removeListener();
        });

        this.setTabCounter();
    }

    _createGrids() {
        this.userAlertsGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getAlertsColumns())
            .setMultiSelect()
            .setRowsPerPage(20)
            .setExternalPagination((pagination) => this._getAlerts(pagination))
            .setGridData([]);

        this.userAlertsGridOptions.isRowSelectable = (row) => {
            if (!row.entity.permissions) {
                return true;
            }
            return row.entity.permissions.manageable;
        };


        this.ignoreGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getIgnoreColumns())
            .setButtons(this._getIgnoreActions());
        /*
         .setBatchActions(this._getIgnoreBatchActions());
         */


        if (this.$stateParams.watcherNameFilter) {
            let f = () => {
                if (this[this.getCurrentAlertGrid()].setFilter) {
                    this[this.getCurrentAlertGrid()].setFilter(
                        this.$stateParams.watcherNameFilter);
                } else {
                    this.$timeout(f);
                }
            };
            this.$timeout(f);
        }


    }


    deleteAlert(alert) {
        this.modal.confirm('Are you sure you want to delete this alert ?')
            .then(() => {
                this.alertsDao.delete({}, {alertID: alert.id}).$promise.then((res) => {
                    this.refreshAlertGrid();
                    this.setTabCounter();
                });
            });
    }

    deleteIgnoreRule(rule) {
        this.modal.confirm('Are you sure you want to delete this ignore rule ?')
            .then(() => {
                this.ignoreDao.deleteIgnore({}, {id: rule.id}).$promise.then((res) => {
                    this._getIgnoreRules();
                    this.setTabCounter();
                });
            });
    }

    ignoreAlerts(alerts) {
        if (!alerts || !alerts.length) {
            return;
        }

        this.IgnoreModal.launchForAlerts(alerts).then((action) => {
            if (action === 'once') {
                this.ignoreOnce(alerts);

            }
            else if (action === 'permanently') {
                this.ignorePermanently(alerts[0]);

            }
            this.setTabCounter();
        });
    }

    ignoreOnce(alerts) {
        let ids = _.map(alerts, 'id');
        this.alertsDao.acknowledge({}, {alert_ids: ids}).$promise.then((response) => {
            this.refreshAlertGrid();
            this.setTabCounter();
        });
    }

    ignorePermanently(alert) {
        let issues = [];
        let licenseIssues = [];
        let doIt = () => {
            let payload = {
                user_name: this.user.userName,
                issues: issues,
                licenses: licenseIssues,
                watch_id: alert.watch_id,
                alert_id: alert.id
            };
            this.ignoreDao.addIgnore({ignore_once: false}, payload).$promise.then((response) => {
                this.ignoreOnce([alert]);
                this.setTabCounter();
            });
        };

        if (alert.method === 'impactAnalysis') {
            if (alert.impact_issue_type == 'license') {
                licenseIssues.push(alert.source_id);
            } else {
                issues.push(alert.source_id);
            }

            doIt();
        }
        else {
            this.getScanIssues(alert).then((scanIssues) => {
                issues = issues.concat(_.map(scanIssues.issues, 'id'));
                licenseIssues = licenseIssues.concat(_.map(scanIssues.licenses, 'summary'));

                doIt();
            });
        }
    }

    getScanIssues(a) {
        let defer = this.$q.defer();

        this.alertsDao.getSingle({}, {alertID: a.id}).$promise.then((alert) => {

            let issues = [];
            let licenseIssues = [];

            alert.impacted_files.forEach((impactedFile) => {

                let details = impactedFile.details;

                details.forEach((detail) => {
                    if (detail.vulnerabilities) {
                        detail.vulnerabilities.forEach((vulnerability) => {
                            if (!_.find(issues, {id: vulnerability.id})) {
                                issues.push(vulnerability);
                            }
                        });
                    }
                    if (detail.banned_licenses) {
                        detail.banned_licenses.forEach((licenseIssue) => {
                            if (!_.find(licenseIssues, {id: licenseIssue.id})) {
                                licenseIssues.push(licenseIssue);
                            }
                        });
                    }
                });
            });

            defer.resolve({issues: issues, licenses: licenseIssues});
        });

        return defer.promise;
    }

    ignoreSingleAlert(row) {
        this.ignoreAlerts([row]);
    }

    ignoreSelectedAlerts() {
        let selectedRows = this[this.getCurrentAlertGrid()].api.selection.getSelectedRows();
        this.ignoreAlerts(selectedRows);
    }

    _getAlerts(pagination) {

        let queryP = this.currentTab === 'user' ? {} : {allusers: true};
        let alertFilter = this.$location.$$search.filter;


        if (alertFilter && this.currentTab !== 'user') {

            //console.log('There is filter in the house!');
            queryP = _.extend({filter: alertFilter}, queryP);
        }
        pagination = pagination || this.defaultPagination;

        let promise = '';
        _.extend(queryP, pagination);

        if (alertFilter) {
            promise = this.alertsDao.getFiltered(queryP).$promise;
            this.isFilteredPage = true;
        } else {
            this.isFilteredPage = false;
            promise = this.alertsDao.get(queryP).$promise;
        }


        return promise;
    }


    setIgnoreAllBtn() {

        if (this.XRayUIPermissions.hasGlobalManage('issues')) {


            if (this.$state.current.name == 'alerts') {

                let q = {
                    direction: 'desc',
                    num_of_rows: 20,
                    order_by: 'created_at',
                    page_num: 1
                };

                let queryP = this.currentTab === 'user' ? {} : {allusers: true};
                if (this.currentTab === 'all') {
                    q.allusers = true;
                }

                this.$timeout(() => {

                    $('.ignore-super-all').remove();
                    if (!$('.ignore-super-all').length && this.allUserAlerts > 0) {
                        let html = '<a ng-click="Alerts.ignoreAllAlerts(' + `${this.allUserAlerts}` + ')"class="ignore-super-all btn batch-action-clear">Ignore All<i class="icon icon-clear"></i> </a>';
                        let $el = $('.alerts .grid-batch-actions');

                        angular.element($el).append(this.$compile(html)(this.$scope));
                    }
                }, 100);
            }
        }
    }

    ignoreAllAlerts(count) {

        this.modal.confirm('Are you sure you want to ignore all alerts ? ' + '(' + count + ')')
            .then(() => {
                let isAllUsers = false;

                if (this.currentTab === 'all') {
                    isAllUsers = true;
                }
                this.alertsDao.acknowledgeAll({allusers: isAllUsers}, {}).$promise.then((response) => {
                    this.refreshAlertGrid();
                    if (this.$state.current.name == 'alerts') {
                        this.allUserAlerts = 0;
                        $('.ignore-super-all').remove();
                        //this.setIgnoreAllBtn();
                    }
                    this.tabsDict.user = 'Alerts (0)';
                });

            });

    }

    _getIgnoreRules() {
        this.ignoreDao.get().$promise.then((ignoreRules) => {
            ignoreRules.forEach((rule) => {
                rule.issuesSummary = _.map(rule.issues, 'summary').join('<br/>');
	            rule.watch_target = this._getWatchTarget(rule);
            });
            this.ignoreGridOptions.setGridData(ignoreRules);
        });
    }

	_getWatchTarget(rule) {
		let targetType = '';
		if (rule.watch_target_type == 'artifact') {
			targetType = 'Every Artifact';
		} else if (rule.watch_target_type == 'builds') {
			targetType = 'All Builds';
		} else {
			targetType = rule.watch_art_id + '::' + rule.watch_target_type + '::' + rule.watch_target_name;
		}

		return targetType;

	}

    _getAlertsColumns() {
        return [
            {
                name: 'Trigger',
                displayName: 'Trigger',
                field: 'trigger',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.trigger}}</div>',
                width: '44%'
            },
            {
                name: 'Top Severity',
                displayName: 'Top Severity',
                field: 'top_severity',
                cellTemplate: '<div class="ui-grid-cell-contents severity" ui-sref="alerts.details({alertID: row.entity.id})"><div class="severity-colorbar" ng-class="(row.entity.top_severity || \'Unknown\').toLowerCase()"></div>{{row.entity.top_severity || \'Unknown\'}}</div>',
                //                enableSorting: false,
                width: '10%'
            },
            {
                name: 'Watch',
                displayName: 'Watch',
                field: 'watch_name',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.watch_name}} ({{row.entity.target}}) {{row.entity.watch_id ? "" : " [DELETED]"}}</div>',
                width: '15%',
                customActions: [{
                    icon: 'icon icon-arrow',
                    tooltip: 'View Watch',
                    callback: row => this.gotoWatch(row),
                    visibleWhen: (row) => (this.currentTab === 'user' || row.user_name == this.user.userName) && row.watch_id
                }]
            },
            {
                name: 'Timestamp',
                displayName: 'Timestamp',
                field: 'created_at',
                cellTemplate: `<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.created_at | date:'medium'}}</div>`,
                sort: {
                    direction: this.uiGridConstants.DESC
                },
                width: '15%'
            },
            {
                name: 'Issues',
                displayName: 'Issues',
                field: 'num_of_issues',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.num_of_issues}}</div>',
                enableSorting: false,
                width: '8%'
            },
            {
                name: 'Artifacts',
                displayName: 'Artifacts',
                field: 'num_of_artifacts',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="alerts.details({alertID: row.entity.id})">{{row.entity.num_of_artifacts}}</div>',
                enableSorting: false,
                width: '8%'
            }
        ];

    }

    _getIgnoreColumns() {
        return [
            {
                name: 'Issues',
                displayName: 'Issues',
                field: 'issuesCount',
                cellTemplate: '<div ng-if="row.entity.issues.length > 1" class="ui-grid-cell-contents">{{row.entity.issues.length}} <strong jf-tooltip="{{row.entity.issuesSummary}}">(See List)</strong></div>' +
                '<div ng-if="row.entity.issues.length === 1" class="ui-grid-cell-contents">{{row.entity.issuesSummary}}</div>',
                width: '24%'
            },
            {
                name: 'Watch Name',
                displayName: 'Watch Name',
                field: 'watch_name',
                width: '25%'
            },
            {
                name: 'Watch Target',
                displayName: 'Watch Target',
                field: 'watch_target',
                width: '25%'
            },
            {
                name: 'User Name',
                displayName: 'User Name',
                field: 'user_name',
                width: '25%'
            },
            {
                name: 'Creation Time',
                displayName: 'Creation Time',
                field: 'created',
                width: '25%'
            }
        ];
    }

    _getAlertsActions() {
        return [
            /*
             {
             icon: 'icon icon-clear',
             tooltip: 'Delete',
             callback: (row) => this.deleteAlert(row)
             },
             */
            {
                icon: 'icon icon-clear',
                tooltip: 'Ignore',
                callback: (row) => this.ignoreSingleAlert(row),
                visibleWhen: (row) => row.permissions.manageable
            }

        ];
    }

    _getIgnoreActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Remove',
                callback: (row) => this.deleteIgnoreRule(row),
                visibleWhen: (row) => row.permissions.manageable
            }

        ];
    }

    _getAlertsBatchActions() {
        return [
            {
                icon: 'clear',
                name: 'Ignore',
                callback: () => this.ignoreSelectedAlerts(),
                visibleWhen: () => this.XRayUIPermissions.checkEdit('alerts') || this.XRayUIPermissions.isAdmin()
            }
        ];
    }

    onChangeTab(tab) {

        let oldTab = this.currentTab;
        this.currentTab = tab.name;
        if (oldTab !== this.currentTab) {
            if (tab.name === 'ignoreRules') {
                this._getIgnoreRules();
            }
            else {
                //                this._getAlerts();

            }
        }
    }

    gotoWatch(row) {
        this.$state.go('watchers.edit', {watcherName: row.watch_name});
    }

    getCurrentAlertGrid() {
        return this.currentTab === 'user' ? 'userAlertsGridOptions' : this.currentTab === 'all' ? 'allAlertsGridOptions' : '';

    }

    refreshAlertGrid() {
        let grid = this.getCurrentAlertGrid();
        if (grid) {
            this[grid].getPage();
        }


    }

    setTabCounter() {

        this.alertsDao.getCount().$promise.then((response) => {
            this.tabsDict.user = this.baseTabsDict['user'] + ` (${response.user_alerts})`;
            this.tabsDict.ignoreRules = this.baseTabsDict['ignoreRules'] + ` (${response.ignore_rules})`;

            this.allUserAlerts = response.user_alerts;

        });


    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/alerts/alerts.controller.js